export default "__VITE_ASSET__QwsodWPva8u3GCl98ABbXQ__"